import { Badge } from "@/components/ui/badge";
import { RISK_BADGE, STATUS_BADGE, STAGE_BADGE, PRIORITY_BADGE } from "@/lib/constants";
import { cn } from "@/lib/utils";

export const RiskBadge = ({ level, className }) => (
  <Badge variant="outline" className={cn("font-medium rounded-md", RISK_BADGE[level] || "bg-muted text-muted-foreground", className)} data-testid="risk-badge">
    {level || "—"}
  </Badge>
);

export const StageBadge = ({ stage, className }) => (
  <Badge variant="outline" className={cn("font-medium rounded-md", STAGE_BADGE[stage] || "bg-muted text-muted-foreground", className)}>
    {stage || "—"}
  </Badge>
);

export const StatusBadge = ({ status, className }) => (
  <Badge variant="outline" className={cn("font-medium rounded-md", STATUS_BADGE[status] || "bg-muted text-muted-foreground", className)}>
    {status || "—"}
  </Badge>
);

export const PriorityBadge = ({ priority, className }) => (
  <Badge variant="outline" className={cn("font-medium rounded-md", PRIORITY_BADGE[priority] || "bg-muted text-muted-foreground", className)}>
    {priority || "—"}
  </Badge>
);

export const PageHeader = ({ title, subtitle, children, testId }) => (
  <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between mb-8 animate-in-up" data-testid={testId}>
    <div>
      <h1 className="font-display text-2xl sm:text-3xl font-semibold tracking-tight text-foreground">{title}</h1>
      {subtitle && <p className="text-sm text-muted-foreground mt-1.5 max-w-2xl leading-relaxed">{subtitle}</p>}
    </div>
    {children && <div className="flex items-center gap-2 flex-wrap">{children}</div>}
  </div>
);

export const EmptyState = ({ icon: Icon, title, subtitle }) => (
  <div className="flex flex-col items-center justify-center py-16 text-center">
    {Icon && <div className="h-12 w-12 rounded-xl bg-muted flex items-center justify-center mb-4"><Icon className="h-6 w-6 text-muted-foreground" /></div>}
    <p className="font-medium text-foreground">{title}</p>
    {subtitle && <p className="text-sm text-muted-foreground mt-1 max-w-sm">{subtitle}</p>}
  </div>
);

export const StatCard = ({ icon: Icon, label, value, hint, tone = "default", testId }) => (
  <div className="bg-card rounded-xl border border-border shadow-card p-5 flex flex-col gap-3 transition-shadow hover:shadow-float" data-testid={testId}>
    <div className="flex items-center justify-between">
      <span className="text-xs font-medium uppercase tracking-wider text-muted-foreground">{label}</span>
      {Icon && (
        <div className={cn("h-8 w-8 rounded-lg flex items-center justify-center",
          tone === "danger" ? "bg-risk-critical/10 text-risk-critical" :
          tone === "warning" ? "bg-risk-medium/10 text-risk-medium" :
          tone === "accent" ? "bg-accent/10 text-accent" : "bg-primary/8 text-primary")}>
          <Icon className="h-4 w-4" />
        </div>
      )}
    </div>
    <div className="mt-auto">
      <span className="font-display text-3xl font-semibold tabular text-foreground">{value}</span>
      {hint && <p className="text-xs text-muted-foreground mt-1">{hint}</p>}
    </div>
  </div>
);
